module.exports = __webpack_public_path__ + "static/media/exist-testing.3382beb9.png";